module.exports = __webpack_public_path__ + "img/icon-bulb.1a1e9849.svg";